import { OrderlineAxios } from './Axios/AxiosOrderline';
import type { OrderlineOrder } from '../types/orderlineOrder';
import type { Address, CodexOrder } from '../types/codexOrder';
import type { CustomerAddressData } from '../types/customerAddress';
import {
  typedGet,
  typedPut,
  typedPost,
  typedDelete,
} from './Axios/TypedWrapper';

export function getOrderDetails(orderRefId: string) {
  return typedGet<CodexOrder | OrderlineOrder>(
    OrderlineAxios,
    `/orderline-api/v2/orders/by-ref-id/${orderRefId}`,
  );
}

export function confirmOrder(params: { reference_id: string }) {
  return typedPost<CodexOrder>(
    OrderlineAxios,
    '/orderline-api/v1/orders/confirm',
    params,
  );
}

export function updateOrder(params: unknown) {
  return typedPut<OrderlineOrder>(
    OrderlineAxios,
    '/orderline-api/v1/orders',
    params,
  );
}

export function capturePaymentOnPg(transactionId: string) {
  return typedPost<unknown>(
    OrderlineAxios,
    `/orderline-api/v1/payments/capture/${transactionId}`,
  );
}

// reference_id is the checkout order's pay-link id; order-line authorizes these
// customer address calls with it because checkout-web has no auth token.
export function getCustomerAddresses(
  bizId: string,
  params: {
    customer_phone: string;
    reference_id: string;
    include_delivery_details?: boolean;
    location_id?: string;
  },
) {
  return typedGet<CustomerAddressData>(
    OrderlineAxios,
    '/orderline-api/v1/customers/addresses',
    params,
    { headers: { 'x-upr-biz-id': bizId } },
  );
}

export function createCustomerAddress(params: {
  bizId: string;
  referenceId: string;
  address: Address;
}) {
  return typedPost<{ address_id: number }>(
    OrderlineAxios,
    '/orderline-api/v1/customers/address',
    { ...(params.address || {}), reference_id: params.referenceId },
    { headers: { 'x-upr-biz-id': params.bizId } },
  );
}

export function deleteCustomerAddresses(
  bizId: string,
  addressId: string,
  params: { customer_phone: string; reference_id: string },
) {
  return typedDelete<unknown>(
    OrderlineAxios,
    `/orderline-api/v1/customers/address/${addressId}`,
    params,
    { headers: { 'x-upr-biz-id': bizId } },
  );
}
